import React from 'react';

export interface ErrorMessage {
  id: string;
  message: string;
  timestamp: Date;
  type?: 'error' | 'warning' | 'info';
}

interface ErrorNotificationProps {
  errors: ErrorMessage[];
  onDismiss: (id: string) => void;
}

export function ErrorNotification({ errors, onDismiss }: ErrorNotificationProps) {
  if (errors.length === 0) return null;

  const getToastClass = (type: 'error' | 'warning' | 'info' = 'error') => {
    switch (type) {
      case 'warning':
        return 'toast toast-warning';
      case 'info':
        return 'toast toast-info';
      case 'error':
      default:
        return 'toast toast-error';
    }
  };

  const getTypeLabel = (type: 'error' | 'warning' | 'info' = 'error') => {
    switch (type) {
      case 'warning': return 'Warning';
      case 'info': return 'Info';
      case 'error':
      default: return 'Error';
    }
  };

  return (
    <div className="toast-container">
      {errors.map((error) => (
        <div key={error.id} className={getToastClass(error.type)}>
          <div className="flex-1">
            <div className="toast-title">{getTypeLabel(error.type)}</div>
            <div className="toast-message">{error.message}</div>
            <div className="toast-timestamp">{error.timestamp.toLocaleTimeString()}</div>
          </div>
          <button onClick={() => onDismiss(error.id)} className="btn-close" title="Dismiss">
            ×
          </button>
        </div>
      ))}
    </div>
  );
}

// Helper function to create error messages
export function createErrorMessage(message: string, type: 'error' | 'warning' | 'info' = 'error'): ErrorMessage {
  return {
    id: Date.now().toString() + Math.random().toString(36).substr(2, 9),
    message,
    timestamp: new Date(),
    type,
  };
}
